import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
//import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'app-editable-group-row-renderer',
    templateUrl: './editable-group-row-renderer.component.html',
    styleUrls: ['./editable-group-row-renderer.component.scss'],
    standalone: false
})
export class EditableGroupRowRendererComponent implements AgRendererComponent {

	action: any;

	get boldLabel(): boolean {
		if (this.params == null) return false;
		return this.params['boldLabel'] != null && this.params['boldLabel'];
}

	get buttonText(): string {
		if (this.params == null || this.params["buttonText"] == null) return "Click";
		return this.params["buttonText"];
	}

	get labelText(): string {
		if (this.params == null) return "";
		let key = this.params.node.key;
		if (this.params["labelTextProperty"] != null && this.params.node.allLeafChildren != null && this.params.node.allLeafChildren.length) {
			key = this.params.node.allLeafChildren[0].data[this.params["labelTextProperty"]];
		}
		return key;	
	}

	rowKey: any;

	params: ICellRendererParams;

  constructor() { }
    refresh(params: any): boolean {
		return false;
    }
	agInit(params): void {
		this.params = params;
		this.action = this.params["action"];
		this.rowKey = this.params.value;

		params.eGridCell?.addEventListener('keydown', (event: KeyboardEvent) => {
			if (event.key === ' ' || event.key === 'Enter') {
				event.preventDefault();
				if (this.action) this.action(this.rowKey);
			}
		});
    }

	click(event: MouseEvent): void {
		event.preventDefault();
		event.stopImmediatePropagation();
		event.stopPropagation();
		if (this.action == null) {
			console.error('no associated action in editable-group-renderer component');
		} else {
			this.action(this.rowKey);
		}		
	}
}
